<template>
    <v-card>
    <v-navigation-drawer
    v-model="right_drawer"
    app dark      
    right
    width="400px"
    >
      <template v-slot:prepend>
        <v-list-item >
         
          <v-list-item-icon>
           <v-icon> mdi-eye </v-icon>    
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">View POI</v-list-item-title>
            
          </v-list-item-content> 
           <v-btn
          icon
          @click.stop="close_right_sidebar" 
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        </v-list-item>
       <v-list-item >
            <v-breadcrumbs large dark :items="b_items">
             <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
     
            </v-breadcrumbs>
        </v-list-item > 

      </template>

      <v-divider></v-divider>

  <template>
  <v-form
    class="mx-2"
    ref="form"
    v-model="valid"
    lazy-validation
  >
     <v-btn v-if="has_quiz"
      color="success"
      class=""
      block
       @click="view_quiz"
      
    >
      <v-icon left dark>mdi-plus-circle</v-icon> View the Quiz of this POI
      </v-btn>
      <v-btn v-else
      color="success"
      class=""
      block
      @click="add_quiz"
      
    >
      <v-icon left dark>mdi-plus-circle</v-icon> Add Quiz for this POI
      </v-btn>

    <v-text-field
      :disabled="!editable"
      v-model="title"
      :counter="100"
      :rules="titleRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Title of the POI
    </template>
    </v-text-field>

    

     <v-text-field
      :disabled="!editable"
      v-model="latitude"
      
      :rules="latitudeRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Latitude
    </template>
    </v-text-field>
     <v-text-field
      :disabled="!editable"
      v-model="longitude"
      
      :rules="longitudeRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Longitude
    </template>
    </v-text-field>

	
    <v-text-field
       @keydown="resetValidation()"
      :disabled="!editable"
      v-model="activation_range"
      
      :rules="activationRangeRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Activation Range (in meters)
    </template>
    </v-text-field>  
   
    <!--
    <v-btn :disabled="!editable" :loading="pick_a_point" block color="blue-grey"  @click="pick_point" >
       <v-icon left>mdi-map-marker</v-icon> Marker
        <template v-slot:loader>
        <span>Waiting to pick a point...</span>
      </template>

    </v-btn>    -->

    <v-textarea
          class="mb-0 pb-0"
          v-model="description"
          :disabled="!editable"
          name="input-7-1"
          label="POI Description"
          value="..."
          hint="Insert something about the POI"
        ></v-textarea>


      <v-checkbox
      v-if="editable"
      v-model="has_qr_code"
      label="This POI has QR code"
      
      ></v-checkbox>

         
      <v-select
        v-if="editable"
        v-model="media_action"
        :items="media_actions"
        label="Media"
        style="max-width: 250px;"
        
      ></v-select>
      <!--
       <v-select
        v-if="file_type=='Video' && editable"
        v-model="video_input_mode"
        :items="video_input_modes"
        label="Video Input Mode"
        style="max-width: 250px;"
        
      ></v-select> -->
      <!--
      <v-text-field
      :disabled="!editable"
      v-if="(file_type=='Video' && video_input_mode=='Link' && editable) || (!editable && multimedia_type==3)"
      v-model="video_link"
      label="Video Link"
      required
    ></v-text-field> -->

     <v-img contain height="150" width="150" class="mx-auto mb-4"  :src="qr_code_link"  v-if="!editable && qr_code_link">
     
     </v-img>

     


    <v-btn v-if="!editable && qr_code_link"
      color="success"
      class="mb-3"
      block
      @click="download_qr_code"
    >
      <v-icon left dark>mdi-download</v-icon> Download QR Code
      </v-btn>


      <v-img max-height="200" contain  class="mb-4"  :src="image_path"  v-if="!editable && image_path">
     
      </v-img>

      <v-btn v-if="!editable && multimedia_type==1"
      color="success"
      class="mb-0 pb-0"
      block
      @click="download_image"
    >
      <v-icon left dark>mdi-download</v-icon> Download POI Image
      </v-btn>
       <!--
       <v-card class="mt-0 pt-0 d-flex justify-center">

      
      <video v-if="!editable && multimedia_type==2" width="320" height="240" controls>
      <source :src="video_path" type="video/mp4">
       Your browser does not support the video tag.
      </video>   
      </v-card> -->
       <!--
       <div v-if="!editable && multimedia_type==2 && video_path" class="player-container">
        <vue-core-video-player preload="none"  :src="video_path"></vue-core-video-player>
      </div> -->
     <!-- <div v-if="!editable && multimedia_type==2 && video_path">
      <vue-player :src="video_path" poster="https://via.placeholder.com/150" title="this is a title"> </vue-player>
   </div>  -->
<!--
  <vue-player  v-if="!editable && multimedia_type==2 && video_path"
	src="http://techslides.com/demos/sample-videos/small.mp4"
	video-placeholder-src="http://techslides.com/demos/sample-videos/small.mp4"
	poster="https://dummyimage.com/600x400/000/fff&text=hover+me"
	title="I'm a title for this video"
	playsinline
	preview-on-mouse
></vue-player> -->
<!--
<vue-player 
	src="http://techslides.com/demos/sample-videos/small.mp4"
	poster="https://dummyimage.com/600x400/000/fff&text=just+a+image"
></vue-player>  -->
      <v-row v-if="!editable && multimedia_type==2 && video_path" justify="center" class="mt-0 pt-0 mb-4 mx-2">
          <Media 
		   :style="{  width: '350px'}"
           :kind="'video'"
           :controls="true"
           :src="[video_path]">  
          </Media>
      </v-row>

       <v-btn v-if="!editable && multimedia_type==2"
      color="success"
      class="mb-3"
      block
      @click="download_video"
    >
      <v-icon left dark>mdi-download</v-icon> Download POI Video
      </v-btn>
       <div class="text-center my-2">
      <v-progress-circular v-if="!editable && multimedia_type==3  && three_d_model_loading" 
      indeterminate
      color="blue"
    ></v-progress-circular> </div>
      <model-obj class="my-2" v-if="!editable && multimedia_type==3  && three_d_model_obj_path" :src="three_d_model_obj_path" :mtl="three_d_model_mtl_path"  @on-load="finished"></model-obj>
      <!--<model-obj class="my-2" v-if="!editable && multimedia_type==3  && three_d_model_obj_path" :src="three_d_model_obj_path" @on-load="finished"></model-obj>-->

      <v-btn v-if="!editable && multimedia_type==3"
      color="success"
      class="mb-3"
      block
      @click="download_model"
      >
      <v-icon left dark>mdi-download</v-icon> Download POI 3D Model
      </v-btn>

     

      <v-file-input :rules="imageRules" v-if="editable && (media_action=='Replace image with another one' || media_action=='Replace video with image' || media_action=='Add image' || media_action=='Replace 3D Model with image')"  v-model="image_file"  prepend-icon="mdi-camera" chips show-size accept="image/*" label="POI Image"></v-file-input>
      <v-file-input :rules="videoRules" v-if="editable && (media_action=='Add video' || media_action=='Replace image with video' || media_action=='Replace video with another one' || media_action=='Replace 3D Model with video')"  v-model="video_file"  prepend-icon="mdi-video" chips show-size accept="video/*" label="POI Video"></v-file-input>
      <v-file-input :rules="modelRules" v-if="editable && (media_action=='Add 3D Model' || media_action=='Replace image with 3D Model' || media_action=='Replace video with 3D Model' || media_action=='Replace 3D Model with another one')"  @change="model_uploaded" v-model="three_d_model_file"  prepend-icon="mdi-video-3d" chips show-size accept=".zip" label="zip containing .obj and .mtl files"></v-file-input>
     
   
<v-btn
     
      color="success"
      class="mr-6 white--text"
      @click="undo"
    
    > 
    <v-icon left dark>{{edit_or_undo_icon}}</v-icon> {{edit_or_undo}}
      
      
    </v-btn>

   

    <v-btn
      :disabled="!editable"
      color="error"
      class="mr-6"
      @click="reset"
    >
      <v-icon left dark>mdi-eraser</v-icon> Reset Form
      
    </v-btn>
    <v-btn
      :loading="waiting_for_storage"
      :disabled="!editable || waiting_for_storage"
      color="success"
      class="mt-4"
      block
      @click="store_poi"
      
    >
     <v-icon left>mdi-content-save</v-icon> Store POI
      
    </v-btn>
    <v-btn
      :disabled="!editable"
      color="error"
      class="mt-4"
      block
      @click="delete_dialog=true"
      
    >
     <v-icon left>mdi-delete</v-icon> Delete POI
      
    </v-btn>

   
  </v-form>

</template>
   
   

    </v-navigation-drawer>



    <v-snackbar
      v-model="instructions_snackbar"
      :timeout= "instructions_snackbar_timeout"
      :multi-line="instructions_snackbar_multiline"
    >
      Click on map in order to set automatically latitude and longitude. Alternatively you can set manually the coordinates.  
      <v-btn
        color="red"
        text
        @click="instructions_snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>





    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :color="snackbar_color"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackbar_text }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

   <v-snackbar
      v-model="file_snackbar"
      :bottom="file_snackbar_y === 'bottom'"
      :color="file_snackbar_color"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="file_snackbar_y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ file_snackbar_text }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>


<template>
  <v-row justify="center">
    <v-dialog v-model="delete_dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Delete POI?</v-card-title>
        <v-card-text>Are you sure you want to delete the POI? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="delete_poi">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>



   
   <v-overlay light :value="overlay" z-index=1000 opacity="0.1">
    <v-progress-circular
      :rotate="-90"
      :size="100"
      :width="15"
      :value="file_upload_percentage"
      color="indigo"
    >
      {{ file_upload_percentage }}
    </v-progress-circular>
    </v-overlay>

  </v-card>

</template>

<script>

    import Media from '@dongido/vue-viaudio'
    //import { vue-core-video-player } from 'vue-core-video-player';
    //import vuePlayer  from  '@algoz098/vue-player';
    import { ModelObj } from 'vue-3d-model';
    import JSZip from 'jszip' 
    import { componentBus } from '../main';
    import axios from 'axios';
    import {  APIS_BASE_URL } from '../constants';
    import router from '../router';
    export default {
        components: { ModelObj, Media },
        name: 'PoiEdit',
        data: function () {
            return {

		instructions_snackbar: false,
		instructions_snackbar_multiline: true,
		instructions_snackbar_timeout: 0,		
      
        mtl_file_data: null,  // it holds the content of mtl file
        images_url_dictionary: {},   // it associates each image in the 3d model zip with a url
        threed_model_zip_file_counter: 0,  // it represents the progress of zip scanning
        threed_model_zip_total_files: 0,
        obj_file_data: null,
        three_d_model_has_images: false,

        
        three_d_model_loading:  null,
        three_d_model_mtl_path:  null,
        three_d_model_obj_path: null,
        video_path: null,
        //video_path: "http://127.0.0.1:8000/api/pois/d62a96a0-2333-46f2-8bc0-3fb2f2efb443/video/stream/",
        
        image_path: null,
        overlay: false,
        file_upload_percentage: null,

        file_upload_config : {
        headers: { 'Content-Type': 'multipart/form-data'},
        onUploadProgress: (progressEvent) => {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            //alert(percentCompleted);
            this.file_upload_percentage = percentCompleted;
        }

        },      

        b_items: [
        {
          text: 'Project',
          disabled: false,
          to: ''
        },
        {
          text: 'POI Editting',
          disabled: true,
          to: ''
          //href: 'breadcrumbs_link_1',
        }
       
      ],      

        media_actions: [],
        media_action: null,
        //video_input_modes: ['Link','File'],
        //video_input_mode: 'Link',

        delete_dialog: false,

        editable: false,
        poi_uuid: null,


        snackbar_color: '',
        mode: '',
        snackbar: false,
        snackbar_text: '',
        timeout: 4000,
        x: null,
        y: 'top',


        file_snackbar_color: '',
        file_snackbar: false,
        file_snackbar_text: '',
        file_snackbar_y: 'bottom',


      waiting_for_storage: false,
      image_file: null,
      video_file: null,
      three_d_model_file: null,
      //pick_a_point: false,
     
      right_drawer: true,



      valid: true,
      title: '',
      titleRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 100) || 'Name must be less than 10 characters',
      ],
      latitude: null,
      latitudeRules: [
        v => !!v || 'Latitude is required',
		v => /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/.test(v) || 'Latitude should be a Real Number',
		// because we removed circles from projects
        //v =>  this.calcCrow(this.relevant_project_latitude,this.relevant_project_longitude,v, this.longitude) * 1000< this.relevant_project_range || 'Updated POI should be inside the circle',
      ],
      longitude: null,
      longitudeRules: [
        v => !!v || 'Longitude is required',
		v => /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/.test(v) || 'Longitude should be a Real Number',
		// because we removed circles from projects
        //v =>  this.calcCrow(this.relevant_project_latitude,this.relevant_project_longitude,this.latitude, v) * 1000< this.relevant_project_range || 'Updated POI should be inside the circle',
        
	  ],
	   activationRangeRules: [
        v => !!v || 'Range is required (in meters)',
		//v => /^[1-9]\d+$/.test(v) || 'Range should be a Positive Integer',
		v => /^[1-9][0-9]*$/.test(v) || 'Activation Range should be a Positive Integer (in meters)',
        
      ], 
      imageRules: [
        v => (!!v  && (this.media_action=='Add image' || this.media_action=='Replace image with another one' || this.media_action=='Replace video with image' || this.media_action=='Replace 3D Model with image')   ) || 'Image is required',   
      ],
       videoRules: [
        v => (!!v  && (this.media_action=='Add video'  || this.media_action=='Replace image with video'  || this.media_action=='Replace video with another one' || this.media_action=='Replace 3D Model with video' )   ) || 'Video is required',   
      ],
       modelRules: [
        v => (!!v  && (this.media_action=='Add 3D Model'  || this.media_action=='Replace image with 3D Model'  || this.media_action=='Replace video with 3D Model' || this.media_action=='Replace 3D Model with another one' )   ) || '3D Model is required',   
      ],
     
      has_qr_code: null,
      qr_code_link: null,
      description: '',
      multimedia_type: null,
      //video_link: null,
      relevant_project: null,
      relevant_project_longitude: null,
      relevant_project_latitude: null,
      relevant_project_range: null,
      has_quiz: null,
	  relevant_quiz_uuid:null,
	  activation_range: null,
      
      

                
            };
        },
        computed: {
            edit_or_undo: function () {
            
            return this.editable ? "Undo" : "Edit POI" 


            },
            edit_or_undo_icon: function () {
            
            return this.editable ? "mdi-undo" : "mdi-pencil" 


            }


        },

       watch: {
		
		editable: {
        handler: function(value, oldVal) {
        if(value) 
		{
		 this.instructions_snackbar=true;
		 componentBus.$emit('pick_a_point', true);
		}
		else 
		 {
		 this.instructions_snackbar=false;
		 componentBus.$emit('stop_picking_point',true);
		 }
        }
    },
		



        threed_model_zip_file_counter: function (val) {
       
        if(val==this.threed_model_zip_total_files)
        {
           if(this.mtl_file_data!=null)
        { 
          
          console.log('time prin: '+this.mtl_file_data);
          Object.keys(this.images_url_dictionary).forEach( (filename) => {
            //this.mtl_file_data=this.mtl_file_data.replace("./"+filename,this.images_url_dictionary[filename].split("/")[3]   );
            this.mtl_file_data=this.mtl_file_data.replace('./', ''   );
            this.mtl_file_data=this.mtl_file_data.replace(filename,this.images_url_dictionary[filename].split("/")[3]   );
           
           //   this.mtl_file_data=this.mtl_file_data.replace('./', ''   );
          });
          console.log("timi meta: "+this.mtl_file_data);
                  
          console.log( "mtl path prev:"+ this.three_d_model_mtl_path);
          console.log( "obj path prev:"+ this.three_d_model_obj_path);
          this.three_d_model_obj_path  =    window.URL.createObjectURL(new Blob([this.obj_file_data])); 
          if( !this.three_d_model_has_images)              // it currently has bugs when mtl targets images.. will have to fix this
              this.three_d_model_mtl_path = window.URL.createObjectURL(new Blob([this.mtl_file_data]));
                 
          console.log( "mtl path:"+ this.three_d_model_mtl_path);
          console.log( "obj path:"+ this.three_d_model_obj_path);
          console.log(this.images_url_dictionary);

        }
        this.three_d_model_obj_path  =    window.URL.createObjectURL(new Blob([this.obj_file_data])); 
        }
    } ,

    longitude: function (val) {
      console.log(val);
      this.$refs.form.validate();
    },
    latitude: function (val) {
      console.log(val);
      this.$refs.form.validate();
    }
    
    
    },




        methods: {
       initialize_3d_model()
       {
        this.three_d_model_has_images= false;
        this.three_d_model_obj_path= null;
        this.threed_model_zip_total_files=0;
        this.mtl_file_data=null;
        this.images_url_dictionary= {};
        this.mtl_file_data= null;
        this.three_d_model_mtl_path= null;
        this.threed_model_zip_file_counter=0;
        this.obj_file_data= null;

       },

       finished()
       {
        this.three_d_model_loading=false;
       },
       
     

       model_uploaded()
       {
       let obj_file_counter=0;
       if(this.three_d_model_file)
       { 
        JSZip.loadAsync(this.three_d_model_file).then( (zip) => {
        Object.keys(zip.files).forEach( (filename) => {
        //console.log(filename);
        if( filename.split('.').pop() =='obj')  obj_file_counter++;   
        //console.log(filename.split('.').pop());
        // zip.files[filename].async('string').then(function (fileData) {
        //  console.log(fileData) // These are your file contents      
        //  })
        })
        if(obj_file_counter!= 1) //alert("it contains .obj file"); else alert("it does not contain it");
        {
        this.three_d_model_file= null;
        this.snackbar_color="error";
        this.snackbar_text="The 3D Model compressed zip file should contain one .obj file!";
        this.snackbar=true;

        }
        })
        
       }
       },  

       toRad(value)
       {
        return value * Math.PI / 180;

       },


        // distance calculation as the crow flies in kilometers
       calcCrow(lat1, lon1, lat2, lon2)
       {
        var R= 6371; //km
        var dLat= this.toRad(lat2-lat1);
        var dLon= this.toRad(lon2-lon1);
        var lat1_rad= this.toRad(lat1);
        var lat2_rad= this.toRad(lat2);
        var a= Math.sin(dLat/2) * Math.sin(dLat/2) + Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1_rad) * Math.cos(lat2_rad);
        var c= 2* Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        var d= R*c;
        return d;
        
       },

        add_quiz()
        {    
        componentBus.$emit('quiz_addition_update_navigation_bar', true);
        router.push({ path: '/quiz_addition', query: { poi_uuid: this.poi_uuid, project_uuid: this.relevant_project }});

        },

        view_quiz()
        {    
        componentBus.$emit('quiz_edit_update_navigation_bar', true);
        router.push({ path: '/quiz_edit', query: { quiz_uuid: this.relevant_quiz_uuid, project_uuid: this.relevant_project, poi_uuid: this.poi_uuid }});

        },

        /*
        pick_point()
         {
          this.pick_a_point= !this.pick_a_point;
          componentBus.$emit('pick_a_point', this.pick_a_point);

         }, */


        reset () {
         this.$refs.form.reset();
         this.image_file=null;
         this.video_file=null;
         this.three_d_model_file=null;
         this.media_actions=[];
         this.media_action=null;
         
         //this.file_type=null;
         componentBus.$emit('destroy_temporary_pin', true);
        },
        undo () {
        this.initialize_3d_model();
        //this.three_d_model_obj_path=null;
        //this.three_d_model_mtl_path=null;
        //this.image_path=null;
        if(this.editable)
            this.fetch_poi_details();
       // this.$refs.form.resetValidation();
        this.editable=!this.editable;
        componentBus.$emit('destroy_temporary_pin', true);
      

        },

        resetValidation () {
        this.$refs.form.resetValidation()
        },

        close_right_sidebar () {
        this.right_drawer = false;
        componentBus.$emit('destroy_temporary_pin', true);

      },
      download_image()
      {
        let download_image_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/image/";

        axios({
        url: download_image_url, 
        method: 'GET',
        responseType: 'blob' 
        }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        //window.location.href = url;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.headers['content-disposition'].split("=")[1]); 
        document.body.appendChild(link);
       link.click();
});
      
        //window.location.href = url;
        //console.log("asdasdasddsa");
      },
      download_model(){
        let download_model_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/3dmodel/";

        axios({
        url: download_model_url, 
        method: 'GET',
        responseType: 'blob' 
        }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        //window.location.href = url;
        const link = document.createElement('a');
        link.href = url
        link.setAttribute('download', response.headers['content-disposition'].split("=")[1]); 
        document.body.appendChild(link);
       link.click();
});
      
        //window.location.href = url;
        //console.log("asdasdasddsa");
      },
      get_model_data(){
        this.three_d_model_obj_path=null;
        this.three_d_model_mtl_path=null;
        let download_model_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/3dmodel/";
        axios({
        url: download_model_url, 
        method: 'GET',
        responseType: 'blob' 
        }).then((response) => {
      
        JSZip.loadAsync(new Blob([response.data])).then( (zip) => {
        
        this.threed_model_zip_total_files =   Object.keys(zip.files).length;
        Object.keys(zip.files).forEach( (filename) => {
      
        if( filename.split('.').pop() =='obj')  
        { 
          zip.files[filename].async('string').then( (fileData) => {
          //this.three_d_model_obj_path = window.URL.createObjectURL(new Blob([fileData]));
          this.obj_file_data=fileData;
          this.threed_model_zip_file_counter++;
       
         })
        }
        else if( filename.split('.').pop() =='mtl')
        { 
          zip.files[filename].async('string').then( (fileData) => {
          this.mtl_file_data=fileData;
        
          this.threed_model_zip_file_counter++;
         
         })
        }
        else if( filename.split('.').pop() =='png' || filename.split('.').pop() =='jpg') {
          this.three_d_model_has_images=true;
          zip.files[filename].async('blob').then( (fileData) => {
          let image_path = window.URL.createObjectURL(new Blob([fileData]));
         
          this.images_url_dictionary[filename]=image_path;
          this.threed_model_zip_file_counter++;
      
          
//window.URL.createObjectURL(new Blob([this.obj_file_data])); 
        
         })
        } else this.threed_model_zip_file_counter++;
      
        })
      
      

        })
         
});
      
     
      },
      get_image_data(){    //this.three_d_model_obj_path = window.URL.createObjectURL(new Blob([fileData]));
        this.image_path=null;
        let get_image_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/image/";
        axios({
        url: get_image_url, 
        method: 'GET',
        responseType: 'blob' 
        }).then((response) => {
        this.image_path = window.URL.createObjectURL(new Blob([response.data]));
        console.log(this.image_path.naturalHeight);
});
      
     
      },

      set_qr_code_link() {
    //try {
      let qr_code_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/qr_code/";

        axios({
        url: qr_code_url, 
        method: 'GET',
        responseType: 'blob' 
        }).then((response) => {
          console.log('response tou set qr code link me status: '+response.status);
      
        if (response.status == "200") 
        {
        this.qr_code_link = window.URL.createObjectURL(new Blob([response.data]));
        this.has_qr_code= true;
        console.log('we have 200 on set qr code link');
        }
        else { this.qr_code_link= null; this.has_qr_code=false; console.log('we do not have 200 on set_qr-code_link'); }
        //window.location.href = url;
        }).catch(error =>  console.log(error)  );
   // }catch(err) { console.log(err) }   
        },
       download_qr_code()
      {
        var download_qr_code_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/qr_code/";

        axios({
        url: download_qr_code_url, 
        method: 'GET',
        responseType: 'blob' 
        }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        //window.location.href = url;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.headers['content-disposition'].split("=")[1]); 
        document.body.appendChild(link);
       link.click();
});
      
        //window.location.href = url;
        //console.log("asdasdasddsa");
      },
      download_video()
      {
        let download_video_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/video/";

        axios({
        url: download_video_url, 
        method: 'GET',
        responseType: 'blob' 
        }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        //window.location.href = url;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.headers['content-disposition'].split("=")[1]); 
        document.body.appendChild(link);
       link.click();
});
      
        //window.location.href = url;
        //console.log("asdasdasddsa");
      },
      fetch_poi_details()
      {   
        
        var get_poi_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/";
        var get_poi_url_encoded= encodeURI(get_poi_url);
   
        axios.get(get_poi_url_encoded)
                    .then(response => {
                    this.title=response.data.title;
                    this.longitude=response.data.point.coordinates[0];
                    this.latitude=response.data.point.coordinates[1];
					this.description=response.data.description;
					this.activation_range=response.data.activation_range;
                    this.multimedia_type=response.data.multimedia_type;
                    if(this.multimedia_type==0)
                     {
                      this.media_actions.push("Leave poi without media");
                      this.media_actions.push("Add image");
                      this.media_actions.push("Add video");
                      this.media_actions.push("Add 3D Model");
                      this.media_action="Leave poi without media";
                     }
                    else if(this.multimedia_type==1)
                    {
                     this.media_actions.push("Keep current image");
                     this.media_actions.push("Delete image");
                     this.media_actions.push("Replace image with another one");
                     this.media_actions.push("Replace image with video");
                     this.media_actions.push("Replace image with 3D Model");
                     this.media_action="Keep current image";
                    }
                    else if(this.multimedia_type==2)
                    {
                     this.media_actions.push("Keep current video");
                     this.media_actions.push("Delete video");
                     this.media_actions.push("Replace video with another one");
                     this.media_actions.push("Replace video with image");
                     this.media_actions.push("Replace video with 3D Model")
                     this.media_action="Keep current video"; 
                    }
                    else if(this.multimedia_type==3)
                    {
                     this.media_actions.push("Keep current 3D Model");
                     this.media_actions.push("Delete 3D Model");
                     this.media_actions.push("Replace 3D Model with another one");
                     this.media_actions.push("Replace 3D Model with image");
                     this.media_actions.push("Replace 3D Model with video")
                     this.media_action="Keep current 3D Model"; 
                    }
                    //this.video_link=response.data.video_link;
                    this.relevant_project=response.data.relevant_project;
                    this.poi_uuid=response.data.poi_uuid;
                    //this.has_qr_code=response.data.has_qr_code;
                    //let payload= {};
                    //payload["point_uuid"]= this.poi_uuid;
                    //payload["relevant_project"]=this.relevant_project;
                    //componentBus.$emit('set_map_view', payload);
                    //if( this.has_qr_code) this.qr_code_link=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/qr_code/";
                     //this.set_qr_code_link();
                    // isos na ksanampei  if( this.has_qr_code)  {   console.log('i am inside poi_fetch and it has qr_code'); this.set_qr_code_link();               }
                       //isos na ksanampei  else this.qr_code_link=null;
                    if(this.multimedia_type==3)  {   this.three_d_model_loading=true;  this.get_model_data(); }
                      else { this.three_d_model_obj_path=null;    this.three_d_model_mtl_path=null;  }
                    if(this.multimedia_type==1)  {    this.get_image_data(); }
                      else { this.image_path=null;   }

                    if(this.multimedia_type==2)  {    this.video_path= APIS_BASE_URL+"/pois/"+this.poi_uuid+"/video/stream/"; }
                      else { this.video_path=null;   }
                      

                    this.has_quiz= response.data.relevant_quiz.length > 0;
                    
                    if (this.has_quiz)
                        this.relevant_quiz_uuid= response.data.relevant_quiz[0].quiz_uuid;

                      
                 

                    var get_relevant_project_url=APIS_BASE_URL+"/projects/"+response.data.relevant_project+"/";
                    var get_relevant_project_url_encoded= encodeURI(get_relevant_project_url);
   
                    axios.get(get_relevant_project_url_encoded)
                    .then(relevant_project_response => {
                   
                    this.relevant_project_longitude=relevant_project_response.data.point.coordinates[0];
                    console.log('relevant project longitude: '+ this.relevant_project_longitude);
                    this.relevant_project_latitude=relevant_project_response.data.point.coordinates[1];
                    console.log('relevant project latitude: '+ this.relevant_project_latitude);
                    this.relevant_project_range=relevant_project_response.data.range;
                    console.log('relevant project range: '+ this.relevant_project_range);

                    this.$refs.form.resetValidation();
                                    
                    })
                    .catch(error => console.log(error));
                    
                        
                    })
                    .catch(error => console.log(error));

                    
      },
      /*
      fetch_relevant_project_details()
      {
       var get_relevant_project_url="https://scent-harm.iccs.gr/nextgen/projects/"+this.relevant_project+"/";
       var get_relevant_project_url_encoded= encodeURI(get_relevant_project_url);
   
        axios.get(get_relevant_project_url_encoded)
                    .then(response => {
                   
                    this.relevant_project_longitude=response.data.point.coordinates[0];
                    this.relevant_project_latitude=response.data.point.coordinates[1];
                    this.relevant_project_range=response.data.range;
                                    
                    })
                    .catch(error => console.log(error));

      }, */

      delete_poi_image()
      {
       let url_delete_image_query=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/image/";
       let encoded_url_delete_image_query= encodeURI(url_delete_image_query);
       axios.delete(encoded_url_delete_image_query)
        .then(function (response) {
        console.log(response.status);
        })

      },
      delete_poi_video()
      {
       let url_delete_video_query=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/video/";
       let encoded_url_delete_video_query= encodeURI(url_delete_video_query);
       axios.delete(encoded_url_delete_video_query)
        .then(function (response) {
        console.log(response.status);
        })

      },
      delete_poi_model()
      {
       let url_delete_model_query=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/3dmodel/";
       let encoded_url_delete_model_query= encodeURI(url_delete_model_query);
       axios.delete(encoded_url_delete_model_query)
        .then(function (response) {
        console.log(response.status);
        })

      },


      delete_poi()
      {
       this.delete_dialog=false;
       componentBus.$emit('deleted_poi', this.poi_uuid);
       componentBus.$emit('destroy_temporary_pin', true);
       //if(this.multimedia_type==1) this.delete_project_image();
       //else if(this.multimedia_type==2) this.delete_project_video();
       let url_delete_poi_query=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/";
       let encoded_url_delete_poi_query= encodeURI(url_delete_poi_query);
       axios.delete(encoded_url_delete_poi_query)
        .then((response) => {
         this.snackbar_color="success";
         this.snackbar_text="The POI has been successfully deleted!"
         this.snackbar=true;
        console.log(response.status);

        
        })
      this.reset();
      this.close_right_sidebar();

      },

       store_poi()
        {
           
          
      console.log("activation range meta to store: "+ this.activation_range);
          let valid= this.$refs.form.validate();
          //let video_link= (this.file_type=='Video' && this.video_input_mode=='Link') ? this.video_link : null;
          //let video= (this.file_type=='Video') ? this.video_file : null;
          //let image= (this.file_type=='Image') ? this.image_file : null;
          let multimedia_type= null;
          if(this.media_action=='Add image' || this.media_action=='Keep current image' || this.media_action=='Replace image with another one' || this.media_action=='Replace video with image' || this.media_action=='Replace 3D Model with image')
              multimedia_type=1;
          else if(this.media_action=='Add video' || this.media_action=='Replace image with video' || this.media_action=='Keep current video' || this.media_action=='Replace video with another one' || this.media_action=='Replace 3D Model with video')
              multimedia_type=2;
          else if(this.media_action=='Leave poi without media' || this.media_action=='Delete image' || this.media_action=='Delete video' || this.media_action=='Delete 3D Model')
              multimedia_type=0;
          else if(this.media_action=='Add 3D Model' || this.media_action=='Replace image with 3D Model' || this.media_action=='Replace video with 3D Model' || this.media_action=='Replace 3D Model with another one' || this.media_action=='Keep current 3D Model')
              multimedia_type=3;

          let will_upload_image= this.image_file!=null && (this.media_action=='Add image' || this.media_action=='Replace image with another one' || this.media_action=='Replace video with image' || this.media_action=='Replace 3D Model with image');
          let will_upload_video= this.video_file!=null && (this.media_action=='Add video' || this.media_action=='Replace image with video' || this.media_action=='Replace video with another one' || this.media_action=='Replace 3D Model with video');
          let will_upload_model= this.three_d_model_file!=null && (this.media_action=='Add 3D Model' || this.media_action=='Replace image with 3D Model' || this.media_action=='Replace video with 3D Model' || this.media_action=='Replace 3D Model with another one');

          if( valid)    
          {
           this.waiting_for_storage=true;
           let url_query=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/";
           let my_url= encodeURI(url_query);
           var payload = {
					title: this.title,
					activation_range: this.activation_range,
                    point: {
                      type: "Point",
                      coordinates: [ parseFloat( this.longitude ),  parseFloat(   this.latitude  )]
                    },
          
                    description: this.description,
                    created_by: "aaabbbccc",
                   
                    //video_link: video_link,
                    multimedia_type: multimedia_type,
                    relevant_project: this.relevant_project
                   
                }

           
           axios.put(my_url, payload,
                    {
                     headers: { 'Content-Type' : 'application/json'}
                               
                        }).then(response => {
                            if (response.status == "200" || response.status == "201" ) {

                              if(this.has_qr_code) 
                               {
                                let create_qr_code_url_query=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/qr_code/";
                                let encoded_create_qr_code_url_query= encodeURI(create_qr_code_url_query);
                                axios.post(encoded_create_qr_code_url_query, {},{
                                
                               
                                  }).then(response => {
                                  //this.qr_code_link= encoded_create_qr_code_url_query;
                                  //alert("ok created");
                                  //this.fetch_poi_details();
                                    this.set_qr_code_link();
                                   console.log(response.status);
                                   });

                               }                
                               else if(this.qr_code_link!=null)    // if user has unchecked qr code and qr code exists...
                                {
                                  let delete_qr_code_url_query=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/qr_code/";
                                  let encoded_delete_qr_code_url_query= encodeURI(delete_qr_code_url_query);
                                  axios.delete(encoded_delete_qr_code_url_query, {},{
                                
                               
                                   }).then(response => {
                                   this.qr_code_link=null;
                                   //alert("ok created");
                                   console.log(response.status);
                                   });
 

                                }
                               if(! (will_upload_image || will_upload_video || will_upload_model) ) 
                               {
                               this.waiting_for_storage=false;
                               this.snackbar_color="success";
                               this.snackbar_text="The POI has been successfully updated!"
                               this.snackbar=true;

                               this.reset();
                               this.editable=false;
                               this.fetch_poi_details();
							   }
							   console.log("stelnei auto to poi uuid"+ this.poi_uuid);
							   payload["poi_uuid"]=this.poi_uuid;
							   console.log("stelnei auto to range: "+ payload["activation_range"]);  
							   //payload["range"]=this.activation_range;
                               componentBus.$emit('updated_poi_payload', payload);
                               componentBus.$emit('destroy_temporary_pin', true);

                               
                               //payload.id=response.data.id;
                               //payload.uuid=response.data.project_uuid;
                               //componentBus.$emit('newly_created_project', payload);

                               //now store the file as well
                               if(will_upload_image ) 
                               {
                                //if(this.has_image) this.delete_project_file();
                                this.file_upload_percentage=0;
                                this.overlay=true;


                                console.log("poi uuid: "+payload.uuid);
                                let upload_image_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/image/";
                                let upload_image_encoded_url= encodeURI(upload_image_url);
                                let formData = new FormData();
                                formData.append('file', this.image_file);

                                axios.post( upload_image_encoded_url,
                                 formData,
                                 //{
                                 //headers: { 'Content-Type': 'multipart/form-data'}
                                 //}
                                 this.file_upload_config
                                ).then( (image_upload_response) =>{

                                if (image_upload_response.status == "201" )
                                   //console.log('SUCCESS with image upload!!');
                                   {
                                    this.overlay=false;
                                    this.waiting_for_storage=false;
                                    this.snackbar_color="success";
                                    this.snackbar_text="The POI has been successfully updated!"
                                    this.snackbar=true;

                                    this.reset();
                                    this.editable=false;
                                    this.fetch_poi_details();
                                   }
                                else
                                 {
                                  this.waiting_for_storage=false;
                                  console.log('FAILURE with image upload!!');
                                  this.file_snackbar_color="error";
                                  this.file_snackbar_text="Problem with POI image storage..."
                                  this.file_snackbar=true;
                                 }
 

                                  })
                                 .catch( () =>{
                                   this.waiting_for_storage=false;
                                   console.log('FAILURE with image upload!!');
                                   this.file_snackbar_color="error";
                                   this.file_snackbar_text="Problem with POI image storage..."
                                   this.file_snackbar=true;

                                   });



                               }
                               else if(will_upload_video) 
                               {
                                this.file_upload_percentage=0;
                                this.overlay=true;
                                 console.log("poi uuid: "+payload.uuid);
                                let upload_video_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/video/";
                                let upload_video_encoded_url= encodeURI(upload_video_url);
                                let formData = new FormData();
                                formData.append('file', this.video_file);

                                axios.post( upload_video_encoded_url,
                                 formData,
                                 //{
                                 //headers: { 'Content-Type': 'multipart/form-data'}
                                 //}
                                 this.file_upload_config
                                ).then( (video_upload_response) =>{

                                if (video_upload_response.status == "201" )
                                  {
                                    this.overlay=false;
                                    this.snackbar_color="success";
                                    this.snackbar_text="The POI has been successfully updated!"
                                    this.snackbar=true;
                                    this.waiting_for_storage=false;
                                   //console.log('SUCCESS with video upload!!');

                                    this.reset();
                                    this.editable=false;
                                   // this.video_path=null;
                                  
                                    this.fetch_poi_details();
                                  }
                                else
                                 {
                                  this.waiting_for_storage=false;
                                  console.log('FAILURE with video upload!!');
                                  this.file_snackbar_color="error";
                                  this.file_snackbar_text="Problem with POI video storage..."
                                  this.file_snackbar=true;
                                 }
 

                                  })
                                 .catch( () =>{
                                   this.waiting_for_storage=false;
                                   console.log('FAILURE with video upload!!');
                                   this.file_snackbar_color="error";
                                   this.file_snackbar_text="Problem with POI video storage..."
                                   this.file_snackbar=true;

                                   });



                               }
                               else if(will_upload_model) 
                               {
                                this.file_upload_percentage=0;
                                this.overlay=true;
                                 console.log("poi uuid: "+payload.uuid);
                                let upload_model_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/3dmodel/";
                                let upload_model_encoded_url= encodeURI(upload_model_url);
                                let formData = new FormData();
                                formData.append('file', this.three_d_model_file);

                                axios.post( upload_model_encoded_url,
                                 formData,
                                 //{
                                 //headers: { 'Content-Type': 'multipart/form-data'}
                                 //}
                                 this.file_upload_config
                                ).then( (model_upload_response) =>{

                                if (model_upload_response.status == "201" )
                                  {
                                    this.overlay=false;
                                    this.snackbar_color="success";
                                    this.snackbar_text="The POI has been successfully updated!"
                                    this.snackbar=true;
                                    this.waiting_for_storage=false;
                                   //console.log('SUCCESS with video upload!!');

                                    this.reset();
                                    this.editable=false;
                                    this.fetch_poi_details();
                                  }
                                else
                                 {
                                  this.waiting_for_storage=false;
                                  this.overlay=false;
                                  console.log('FAILURE with 3D Model upload!!');
                                  this.file_snackbar_color="error";
                                  this.file_snackbar_text="Problem with POI 3D Model storage..."
                                  this.file_snackbar=true;
                                 }
 

                                  })
                                 .catch( () =>{
                                   this.waiting_for_storage=false;
                                   this.overlay=false;
                                   console.log('FAILURE with 3D Model upload!!');
                                   this.file_snackbar_color="error";
                                   this.file_snackbar_text="Problem with POI 3D Model storage..."
                                   this.file_snackbar=true;

                                   });



                               }
                               else if(this.media_action=='Delete image')
                                    this.delete_poi_image()
                               else if(this.media_action=='Delete video')
                                    this.delete_poi_video();
                               else if(this.media_action=='Delete 3D Model')
                                    this.delete_poi_model();
                               //console.log(response.data);
                            }
                            else {
                                //alert("something went wrong");
                                this.waiting_for_storage=false;
                                this.overlay=false;
                                this.snackbar_color="error";
                                this.snackbar_text="Problem with the POI update..."
                                this.snackbar=true;
                            }
                            //this.reset();
                            //this.editable=false;
                            //this.fetch_poi_details();
                           
                    })
                    .catch(error => {
                        console.log(error);
                        //alert("something went wrong"+ error);
                        this.waiting_for_storage=false;
                        this.overlay=false;
                        this.snackbar_color="error";
                        this.snackbar_text="Problem with the POI update..."
                        this.snackbar=true;
                    });


 
          }
          
        

        }

       
       
        },

         
     

        
        mounted() {
         
       
    
        this.video_path=null;
        
        let _this = this;
        componentBus.$on('poi_to_edit_uuid', poi_uuid => {  
        this.reset();
        this.initialize_3d_model();
        if(poi_uuid!=_this.poi_uuid)
         router.replace({ path: '/poi_edit', query: { poi_uuid: poi_uuid, project_uuid: _this.relevant_project }});
        this.editable=false;
		this.poi_uuid= poi_uuid;
		componentBus.$emit('destroy_temporary_pin', true);    // experimental
      
        // prepei na vgei this.video_path=null;
        //prepei na vgei this.three_d_model_obj_path=null;
        //prepei na vgei  this.three_d_model_mtl_path=null;
        this.image_path=null;
        this.fetch_poi_details();
        this.right_drawer = true;
        this.set_qr_code_link();
        
        
            });

            componentBus.$on('selected_point_coordinates', (poi_point_coordinates) => {
              //if(this.pick_a_point)
                //{
               
                this.latitude=poi_point_coordinates.lat;
                this.longitude=poi_point_coordinates.lng;
               // this.pick_a_point= !this.pick_a_point;
               // }
            });

         



      
        
         this.poi_uuid= this.$route.query.poi_uuid;
         this.set_qr_code_link();
        
         //let payload={};
         //payload['point_uuid']=this.poi_uuid;
         //payload['type']='poi'
         //componentBus.$emit('focus_on_pin',payload);
         this.fetch_poi_details();
         this.$refs.form.resetValidation()
         this.b_items[0]['to']='project_edit?uuid='+this.$route.query.project_uuid;
         
         
        
    
           
        },
        destroyed() {
		  componentBus.$emit('stop_picking_point', true);
		  componentBus.$off('poi_to_edit_uuid');
          componentBus.$off('selected_point_coordinates');
          componentBus.$emit('destroy_temporary_pin', true);
          this.video_path=null;
          
		},
		
    }
</script>

<style scoped>
   
</style>
